const initialState = {
    urlValue: '',
};

const urlReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_URL':
            return {
                ...state,
                urlValue: action.payload,
            };
        default:
            return state;
    }
};

export default urlReducer;